export default {"src":"/_next/static/media/outrun.151024ad.svg","height":68,"width":90};